var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7537_9213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.97059 0.977539C5.7919 0.977539 5.6132 1.04262 5.4832 1.17285L1.17301 5.48304C0.903919 5.75213 0.903919 6.18919 1.17301 6.45783L5.4832 10.7689C5.6132 10.8989 5.7865 10.9704 5.97059 10.9704C6.15469 10.9704 6.32753 10.8989 6.45799 10.7689L10.7691 6.45783C11.0382 6.18874 11.0382 5.75168 10.7691 5.48304L6.45799 1.17285C6.32776 1.04262 6.14929 0.977539 5.97059 0.977539ZM5.97059 1.97008L9.97095 5.97044L5.97059 9.97079L1.97024 5.97044L5.97059 1.97008ZM5.51605 3.69771V6.42498H6.42514V3.69771H5.51605ZM5.51605 7.33407V8.24316H6.42514V7.33407H5.51605Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7537_9213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9091,
    height: 10.9091,
    fill: "white",
    transform: "translate(0.516113 0.516113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.4ed9d530953102c6d0f4765a0f22b05b.svg";
export { ForwardRef as ReactComponent };